import { Provider } from '@angular/core';

import { PAGE_VIEW_DATA_PROVIDER } from '@frontend/vanilla/core';

import { NetworkPerformancePageViewDataProvider } from './network-performance-page-view-data-provider';

export function provideTracking(): Provider {
    return { provide: PAGE_VIEW_DATA_PROVIDER, useClass: NetworkPerformancePageViewDataProvider, multi: true };
}
